"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const propTypes = {
    /** The config object for the customer */
    config: prop_types_1.object.isRequired,
    /** The alt providers data from state machine context */
    altProviders: (0, prop_types_1.arrayOf)(prop_types_1.object),
    /** The services object containing URL creation functions */
    services: prop_types_1.object.isRequired,
    /** Tracking function */
    track: prop_types_1.func.isRequired
};
const defaultProps = {
    altProviders: null
};
/**
 * AltProviders component renders alternative providers in the sidebar
 * Extracted from Sidebar for better separation of concerns
 */
function AltProviders({ config, altProviders, services, track }) {
    const detailedAltProviders = (0, react_1.useMemo)(() => {
        return (0, utils_1.transformProvidersForDisplay)(altProviders, config);
    }, [altProviders, config]);
    // Don't render if no alt providers data
    if (!detailedAltProviders.length) {
        return null;
    }
    return (react_1.default.createElement(styles_1.AltProvidersContainer, { "data-testid": "dbw-alt-providers" },
        react_1.default.createElement(styles_1.AltProvidersHeader, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.altProvidersHeader))),
        react_1.default.createElement(provider_components_1.MiniProviderCardList, { createAvailabilityUrl: services.createAvailabilityUrl, createProviderUrl: services.createProviderUrl, providers: detailedAltProviders, track: track })));
}
AltProviders.propTypes = propTypes;
AltProviders.defaultProps = defaultProps;
exports.default = AltProviders;
//# sourceMappingURL=AltProviders.js.map